import styled from "styled-components";

//Interfaces
import { ChatPropsInterface } from "./interfaces";

//Assets
import colors from "../../assets/css/colors";

export const Container = styled.div`
    width: 100%;
    height: 100%;

    display: flex;
    flex-direction: column;

    padding-left: 38px;
    padding-right: 14px;
    padding-top: 48px;

    @media (max-width: 768px){
      padding: 0;
      padding-top: 20px;
      height: 89vh;
    }
`;

export const ChatHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 15%;

    margin-bottom: 31px;

    @media (max-width: 768px){
      display: block;
      margin-bottom: 20px;
      height: 25%
    }
`;

export const BackButton = styled.div`
  display: none;
  margin-right: 20px;

  @media (max-width: 768px) {
    display: flex;
  }
`;

export const LogoContainer = styled.div`
    width: 52px;
    height: 53px;
    
    display: flex;
    justify-content: center;
    align-items: center;

    margin-right: 36px;

    box-shadow: 0px 1px 6px #00000029;
    border-radius: 13px;
`;

export const LogoImage = styled.img`
  max-width: 47px;
  max-height: 48px;
`;


export const ChatSubject = styled.h2`
    font: normal normal normal 16px Circular Std Book;
    color: #454546;
    margin-bottom: 9px;
    line-height: 1;
`;

export const ChatDetail = styled.span`
    font: normal normal normal 12px Circular Std Book;
    color: #B8B4CC;
    margin-right: 44px;
`;

export const StatusContainer = styled.div`
    width: 148px;
    height: 33px;

    display: flex;
    justify-content: center;
    align-items: center;

    border: 1px solid #F58B1E;
    border-radius: 17px;
    font: normal normal normal 12px Circular Std Book;
    color: #F58B1E;

    cursor: pointer;

    @media (max-width: 768px){
      margin: auto;
      margin-top: 25px;
    }
`;

export const ChatBody = styled.div`
    width: 100%;
    height: 85%;
    
    display: flex;
    flex-direction: column;
    flex-grow: 1;
`;

export const ChatMessagesContainer = styled.div`
    height: 80%;

    margin-left: -38px;
    margin-right: -44px;

    padding-top: 37px;
    padding-left: 38px;
    padding-right: 29px;
    padding-bottom: 37px;

    background: #fcfcfd 0% 0% no-repeat padding-box;

    overflow-y: auto;

    ::-webkit-scrollbar-track {
        background-color: ${colors.scrollBarBackground};
    }
    ::-webkit-scrollbar {
        width: 6px;
        background: ${colors.scrollBarBackground};
    }
    ::-webkit-scrollbar-thumb {
        background: ${colors.scrollBarThumb};
    }

    @media (max-width: 768px){
      height: 75%;
      padding: 0;
      padding-left: 10px;
      padding-right: 10px;
      padding-top: 20px;
      margin: 0;
    }
`;

export const MessageBlock = styled.div`
  width: 100%;
  display: flex;
  margin-bottom: 20px;
  justify-content: ${(p: ChatPropsInterface) => p.isUserMessage ? "flex-end" : "flex-start"};
`

export const Message = styled.div`
  max-width: 469px;
  background: ${(p: ChatPropsInterface) => p.isUserMessage ? colors.grayLight : colors.grayLightest}; 
  border-radius: 16px;
  padding: 12px;

  @media (max-width: 768px){
    max-width: 80%;    
  }
`;

export const MessageText = styled.div`
  font: normal normal normal 12px Circular Std Book;
  color: ${colors.tertiary};
  word-wrap: break-word;
`;

export const MessageFooter = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  font: normal normal normal 10px Circular Std Book;
  color: ${colors.grayDark};
  margin-top: 3px;
`;

export const FormContainer = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  margin-top: 17px;
  margin-bottom: 14px;
`;

export const Textarea = styled.textarea`
  width: 75%;
  height: 100%;
  resize: none;
  background: ${colors.white};
  color: ${colors.tertiary};
  border-radius: 7px;
  border: 1px solid rgba(194, 194, 194, 0.2);
  font-size: 0.8em;
  font-weight: 300;
  line-height: 1.45;
  outline: none;
  padding: 0.4em 1em 0.4em;
  -webkit-transition: 0.18s ease-out;
  -moz-transition: 0.18s ease-out;
  -o-transition: 0.18s ease-out;
  transition: 0.18s ease-out;

  -webkit-box-shadow:  -4px 3px 19px -8px rgba(194, 194, 194, 0.726);
  -moz-box-shadow:  -4px 3px 19px -8px rgba(194, 194, 194, 0.726);
  box-shadow:  -4px 3px 19px -8px rgba(194, 194, 194, 0.726);

  &:hover {
    border: 1px solid rgba(255, 169, 89, 0.2);
    -webkit-box-shadow: 0px 3px 33px -4px rgba(255, 202, 174, 0.815);
    -moz-box-shadow: 0px 3px 33px -4px rgba(255, 202, 174, 0.815);
    box-shadow: 0px 3px 33px -4px rgba(255, 202, 174, 0.815);
  }

  &:focus {
    color: var(--gray);
    border: 1px solid ${colors.secondaryDark};
    -webkit-box-shadow: 0px 3px 33px -4px rgba(255, 202, 174, 0.815);
    -moz-box-shadow: 0px 3px 33px -4px rgba(255, 202, 174, 0.815);
    box-shadow: 0px 3px 33px -4px rgba(255, 202, 174, 0.815);
  }

  &:disabled {
    background-color: ${colors.grayLightest};
  }

  &::-webkit-input-placeholder {
    /* WebKit browsers */
    text-transform: none;
  }
  &:-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    text-transform: none;
  }
  &::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    text-transform: none;
  }
  &:-ms-input-placeholder {
    /* Internet Explorer 10+ */
    text-transform: none;
  }
  &::placeholder {
    /* Recent browsers */
    text-transform: none;
  }
`;

export const SendButtonContainer = styled.div`
  width: 25%;
  height: 100%;
  display: flex;
  align-items: center;
  padding-left: 35px;

  @media (max-width: 768px){
    padding-left: 15px;
  }
`;

export const SendButton = styled.button`
  width: 100%;
  height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${colors.white};
  border: 1px solid ${colors.grayLight};
  border-radius: 18px;
  outline: 0;
  font: normal normal normal 12px Circular Std Book;
  color: ${colors.grayDark};
  text-transform: uppercase;
  transition: all.3s ease;

  &:focus{
    outline: 0;
  }

  &:hover{
    color: ${colors.white};
    background-color: ${colors.primary};
    border: 1px solid ${colors.primary};
  }

  &:active{
    color: ${colors.white};
    background-color: ${colors.primary};
    border: 1px solid ${colors.primary};
  }
`